// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"796ff472","796":"da571ef6"}[chunkId] + ".chunk.js";
};